module.exports = __webpack_public_path__ + "static/media/roof-flat.bccae5bd.png";